import React from 'react'
import './Fees_plan.css'
import ResponsiveAppBar from '../../Component/Navbar/Navbar'
import Footer from '../../Component/Footer/Footer'

function Fees_plan() {
    return (
        <div className='main-fees-plan'>
            <ResponsiveAppBar />
            <div className='main-fees-plan-top-div'>
                <div className="top-section-center-div">
                    <div>
                        <img className='arabic-img' src="/Images/arabic.png" alt="arabic" />
                    </div>
                    <p className="top-section-english-text">
                        The best amongst you is the one who learns the <br /> Qur'an and teaches it{' '}
                    </p>
                    <a
                        href="https://wa.me/923194908790"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="top-section-button"
                    >
                        Book a Free Trial
                    </a>
                </div>

            </div>
            <div className='content-top-feeswraper-wrape'>
                <p className='heading-fees'>Fees Plan</p>
                <p className='sb-heading'>Find the Right Plan for You</p>

                <div className='fees-plan-card-wrape'>
                    <div className='fees-plan-card-top-padding'>
                        <div className='fees-plan-card'>
                            <div className='fees-plan-top-div-btn-wrape'>
                                <div className='fees-plan-top-div-btn'>
                                    <p className='startup-text'>Startup</p>
                                </div>
                            </div>
                            <img className='white-line' src='/Images/Line 2.png' alt='line' />
                            <div className='fees-in-dollar-wrape'>
                                <p className='dollar-text'>$20</p>
                                <p className='sb-text-dollar'>Per member, per Month</p>
                            </div>
                            <img className='white-line' src='/Images/Line 2.png' alt='line' />
                            <div className='facilities-provide-wrape'>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>3 Days Per Week</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>30 Minutes Per day</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>12 Classes Per Month</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>Time as per your choice</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>One-On-One Teaching</p>
                                </div>
                            </div>
                            <div className='fees-plan-bottom-btn-wrape'>
                            <a
                                    href="https://wa.me/923194908790"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fees-plan-bottom-btn"
                                >
                                    Book a Free Trial
                                </a>
                            </div>

                        </div>
                    </div>
                    <div className='fees-plan-card-second'>
                        <div className='fees-plan-top-div-btn-wrape'>
                            <div className='fees-plan-top-div-btn-second'>
                                <p className='startup-text-second'>Premium </p>
                            </div>
                        </div>
                        <img className='white-line' src='/Images/Line 4.png' alt='line' />
                        <div className='fees-in-dollar-wrape'>
                            <p className='dollar-text-second'>$25</p>
                            <p className='sb-text-dollar-second'>Per member, per Month</p>
                        </div>
                        <img className='white-line' src='/Images/Line 4.png' alt='line' />
                        <div className='facilities-provide-wrape'>
                            <div className='top-tick-or-text-wrape'>
                                <img src='/Images/feesplan-tick-white.svg' alt='tick' />
                                <p className='tick-text-second'>4 Days Per Week</p>
                            </div>
                            <div className='top-tick-or-text-wrape'>
                                <img src='/Images/feesplan-tick-white.svg' alt='tick' />
                                <p className='tick-text-second'>30 Minutes Per day</p>
                            </div>
                            <div className='top-tick-or-text-wrape'>
                                <img src='/Images/feesplan-tick-white.svg' alt='tick' />
                                <p className='tick-text-second'>16 Classes Per Month</p>
                            </div>
                            <div className='top-tick-or-text-wrape'>
                                <img src='/Images/feesplan-tick-white.svg' alt='tick' />
                                <p className='tick-text-second'>Time as per your choice</p>
                            </div>
                            <div className='top-tick-or-text-wrape'>
                                <img src='/Images/feesplan-tick-white.svg' alt='tick' />
                                <p className='tick-text-second'>One-On-One Teaching</p>
                            </div>
                        </div>
                        <div className='fees-plan-bottom-btn-wrape'>
                        <a
                                    href="https://wa.me/923194908790"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fees-plan-bottom-btn-second"
                                >
                                    Book a Free Trial
                                </a>
                        </div>

                    </div>
                    <div className='fees-plan-card-top-padding'>
                        <div className='fees-plan-card'>
                            <div className='fees-plan-top-div-btn-wrape'>
                                <div className='fees-plan-top-div-btn'>
                                    <p className='startup-text'>Premium Plus</p>
                                </div>
                            </div>
                            <img className='white-line' src='/Images/Line 2.png' alt='line' />
                            <div className='fees-in-dollar-wrape'>
                                <p className='dollar-text'>$30</p>
                                <p className='sb-text-dollar'>Per member, per Month</p>
                            </div>
                            <img className='white-line' src='/Images/Line 2.png' alt='line' />
                            <div className='facilities-provide-wrape'>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>5 Days Per Week</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>30 Minutes Per day</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>20 Classes Per Month</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>Time as per your choice</p>
                                </div>
                                <div className='top-tick-or-text-wrape'>
                                    <img src='/Images/feesplan-tick-green.svg' alt='tick' />
                                    <p className='tick-text'>One-On-One Teaching</p>
                                </div>
                            </div>
                            <div className='fees-plan-bottom-btn-wrape'>
                                <a
                                    href="https://wa.me/923194908790"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fees-plan-bottom-btn"
                                >
                                    Book a Free Trial
                                </a>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div className='whatsapp-static'>
        <a href="https://wa.me/923194908790" target="_blank" rel="noopener noreferrer">
          <img className='static-img-whatsapp' src='/Images/whatsappstatic.svg' alt="static" />
        </a>
      </div>
            <Footer />

        </div>
    )
}

export default Fees_plan
